<template>
  <div class="interaction-container">
    <label @click="handleDropDownClick()">{{ label }}</label>
    <div class="dropdown__container">
      <div
        class="selected_wrapper"
        :class="{ open: isOpen }"
        @click="handleDropDownClick()"
      >
        <span class="dropdown_label" v-if="activeOption">
          <img
            v-if="activeOption.image_url"
            :src="activeOption.image_url"
            :alt="activeOption.title"
          />
          <span>{{
            activeOption == decideLaterOption
              ? decideLaterText
              : activeOption.title
          }}</span>
        </span>
        <span class="dropdown_label" v-else>
          {{ emptyOption.label }}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.5"
          stroke="currentColor"
          class="chevron"
          :class="{ active: isOpen }"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
          />
        </svg>
      </div>
      <dropdown-wrapper :open="isOpen">
        <div class="option_container">
          <div
            v-if="chooseNowOption"
            class="chooseNowOption"
            @click="handleModalOpen(true)"
          >
            <div
              class="option"
              :data-option-val="chooseNowOption.value"
              v-html="chooseNowOption.label"
            />
          </div>
          <div
            v-if="decideLaterOption"
            :class="{
              additional_detail: decideLaterOption.description,
              details_wrapper: decideLaterOption.description,
            }"
            @click="handleDFLOption"
          >
            <div
              class="option"
              :data-option-val="decideLaterOption.value"
              v-html="decideLaterOption.label"
            />
            <div v-if="decideLaterOption.description">
              <div class="description" v-html="decideLaterOption.description" />
            </div>
          </div>
        </div>
      </dropdown-wrapper>
    </div>
    <transition name="fade" @enter="onModalOpen">
      <div class="modal_wrapper" v-if="modalOpen && displayedOption">
        <div
          class="modal_container"
          ref="container"
          @click="checkClick"
          @keydown="checkKeyDown"
          tabindex="1"
        >
          <div class="modal_overlay">&nbsp;</div>
          <div class="modal_content">
            <button
              title="Close (Esc)"
              type="button"
              class="closer"
              @click.prevent="handleModalOpen()"
            >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>

            </button>
            <div class="scroll_container">
              <div class="modal_heading">
                <h3>{{ modalHeading }}</h3>
                <div class="button_container" ref="modalActions"> 
                  <div class="flex-wrapper">
                      <div class="action_button" @click="handleFabricSelect">
                        {{ chooseText }}
                      </div>
                      <div class="sticky-fabric__filter-open" @click="filtersOpen = true">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5" />
                        </svg>
                      </div>
                    </div>
                    <div
                      class="action_button inverse mobile--second"
                      @click="
                        () => {
                          this.handleDecideLater();
                          this.handleModalOpen();
                        }
                      "
                    >
                      {{ decideLaterText }}
                    </div>
                    

                </div>
              </div>
              <div>
                <div class="active-image_wrapper" :class="{'product__images--invert': isInverted}">
                  <div class="image_container">
                    <AppImage
                      :key="activeImage"
                      :lazy-src="activeImageUrl"
                    />
                  </div>
                </div>
                <div class="modal_active_container">
                  <div class="modal_active_option">
                    <div
                      class="modal_text"
                      :class="{
                        detail_background: displayedOption.background_needed,
                      }"
                    >
                      <div class="option_title">{{ displayedOption.title }}</div>
                      <div class="option_collection">
                        {{ displayedOption.fabric_options[0] }}
                      </div>
                    </div>
                    <div class="modal_image">
                      <AppImage
                        :key="displayedOption.image_url"
                        :lazy-src="displayedOption.image_url"
                        :alt="displayedOption.title"
                      />
                    </div>
                  </div>
                  <div
                    class="modal_yaml_one"
                    @click="handleYAMLClick(displayedOption.ymal_1)"
                  >
                    <div
                      class="modal_text"
                      :class="{
                        detail_background: displayedOption.ymal_1.background_needed,
                      }"
                    >
                      <div class="yaml_heading">{{ YAML_TEXT }}</div>
                      <div class="option_title">
                        {{ displayedOption.ymal_1.title }}
                      </div>
                      <div class="option_collection">
                        {{ displayedOption.ymal_1.fabric_options[0] }}
                      </div>
                    </div>
                    <div class="modal_image">
                      <AppImage
                        :key="displayedOption.ymal_1.image_url"
                        :lazy-src="displayedOption.ymal_1.image_url"
                        :alt="displayedOption.ymal_1.title"
                      />
                    </div>
                  </div>
                  <div
                    class="modal_yaml_two"
                    @click="handleYAMLClick(displayedOption.ymal_2)"
                  >
                    <div
                      class="modal_text"
                      :class="{
                        detail_background: displayedOption.ymal_2.background_needed,
                      }"
                    >
                      <div class="yaml_heading">{{ YAML_TEXT }}</div>
                      <div class="option_title">
                        {{ displayedOption.ymal_2.title }}
                      </div>
                      <div class="option_collection">
                        {{ displayedOption.ymal_2.fabric_options[0] }}
                      </div>
                    </div>
                    <div class="modal_image">
                      <AppImage
                        :key="displayedOption.ymal_2.image_url"
                        :lazy-src="displayedOption.ymal_2.image_url"
                        :alt="displayedOption.ymal_2.title"
                      />
                    </div>
                  </div>
                </div>
                <div class="modal_options" ref="modalOptions">
                <div
                  v-for="option in this.options"
                  :key="option.title"
                  class="modal_option"
                  :class="{ is_active: option === displayedOption }"
                  @click="handleOptionClick(option)"
                >
                  <div v-if="option === displayedOption" class="active_ring">
                    &nbsp;
                  </div>
                  <div
                    class="modal_text"
                    :class="{ detail_background: option.background_needed }"
                  >
                    <div class="option_title">{{ option.title }}</div>
                    <div class="option_collection">
                      {{ option.fabric_options[0] }}
                    </div>
                  </div>
                  <div class="modal_image">
                    <AppImage :lazy-src="option.image_url" :alt="option.title" />
                  </div>
                </div>
                </div>
              </div>
            </div>
            <div class="sticky-fabrics">
              <div class="sticky-fabric-wrapper">
                <div class="sticky-fabric-details">
                    <div class="sticky-image" :class="{
                      lightBG: displayedOption.background_needed
                    }">
                      <AppImage
                        :key="displayedOption.image_url"
                        :lazy-src="displayedOption.image_url"
                        :alt="displayedOption.title"
                      />
                    </div>
                    <div class="sticky-fabric-details--content">
                      <div class="sticky-title">{{ displayedOption.title }}</div>
                      <div class="sticky-collection">
                        {{ displayedOption.fabric_options[0] }}
                      </div>
                    </div>
                    <div class="action_button" @click="handleFabricSelect">
                      {{ chooseText }}
                    </div>
                    <div class="sticky-fabric__filter-open" @click="filtersOpen = true">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5" />
                      </svg>
                    </div>
                  </div>
                  <div class="action_button" @click="handleFabricSelect">
                    {{ chooseText }}
                  </div>
              </div>
            </div>
            
            <transition name="fade">
              <div class="filters_container" v-if="filtersOpen">
                <div class="filters_overlay" @click="filtersOpen = false">&nbsp;</div>
                <div class="filters_wrapper">
                  <button data-v-239f167e="" title="Close (Esc)" type="button" class="closer" @click="filtersOpen = false">
                    <svg data-v-239f167e="" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                      <path data-v-239f167e="" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                  <!-- TODO move this to the config -->
                  <h3>Filter</h3>
                  <div class="filters">
                    <div class="filter" v-for="(filter, index) in this.fabricFilters" :key="`ff-${filter.heading}`" ref="filter" >
                      <div class="filter_toggle" @click="handleFilterClick(index)">
                        <div class="filter_heading">{{filter.heading}}</div>
                        <div class="filter_indicator">
                          <svg class="td--vertical-part" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                          </svg>
                          <svg class="td--horizontal-part" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                          </svg>  
                        </div>
                      </div>
                      <div class="filter_values" ref="content">
                        <template v-if="filter.type ==='COLOR'">
                          <div v-for="value in  filter.values" :key="`fv--${value}`" class="filter-option" :class="{active: value.active}" @click="handleFilterSelected(filter,value)">
                            <div class="colour-indicator" :style="`--filter-colour:${colorConfig.find((color) => color.name == value.value)?.code}`">&nbsp;</div>
                            {{ value.value }}
                          </div>
                        </template>
                        <template v-else-if="filter.type ==='RADIO'">
                          <div v-for="value in  filter.values" :key="`fv--${value}`" class="filter-option" :class="{active: value.active}" @click="handleFilterSelected(filter,value)">
                            {{ value.value }}
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>             
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import DropdownWrapper from "./DropdownWrapper.vue";
import AppImage from "./AppImage.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: { DropdownWrapper, AppImage },
  name: "FabricModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    displayImage: {
      type: Boolean,
      default: false,
    },
    decideLaterValue: {
      type: String,
    },
    modalDecideLaterText: {
      type: String,
    },
    modalHeading: {
      type: String,
      default: "This is the heading",
    },
    modalActionText: {
      type: String,
      default: "This is the action",
    },
    optionFunction: {
      type: String,
    },
    defaultValueFunction: {
      type: String,
    },
    setFunction: {
      type: String,
    },
    setStateFunction: {
      type: String,
    },
    emptyOptionFunction: {
      type: String,
    },
    activeOptionFunction: {
      type: String,
    },
    chooseNowOptionFunction: {
      type: String,
    },
    decideLaterOptionFunction: {
      type: String,
    },
    chooseTextFunction: {
      type: String,
    },
    decideLaterTextFunction: {
      type: String,
    },
  },
  data() {
    return {
      modalOpen: false,
      filtersOpen: false,
      displayedOption: this.activeOption,
      availableOptions: [],
      YAML_TEXT: "You May Also Like",
      STICKY_CLASS: "sticky-stuck",
      // TODO move this to a config setting
      IMAGE_URL_TEMPLATE: "/cdn/shop/files/{productTitle}_{fabricName}_FRONT.jpg"
    };
  },
  watch: {
    modalOpen(newIsOpen) {
      if (newIsOpen) {
        document.querySelector('body').classList.add('mr--modal-open')
        document.querySelector('html').classList.add('mr--modal-open')
      } else {
        document.querySelector('body').classList.remove('mr--modal-open')
        document.querySelector('html').classList.remove('mr--modal-open')
      }
    },
    options(newOptions) {
      if (newOptions.length) {
        if (!newOptions.includes(this.displayedOption)) {
          this.displayedOption = newOptions[0]
          this.maybeSetRenderingImage()
        }
      }
    }
  },
  computed: {
    options() {
      let fabricOptionsCopy = [...this.$store.getters[this.optionFunction]]
      if (this.activeFilters.length) {
        const filteringObject = {}
        this.activeFilters.forEach((filter) => {
          filteringObject[filter.appValue] = filter.values.map((value) => value.value)
        })
        fabricOptionsCopy = fabricOptionsCopy.filter((fabricOption) => {
          let matches = 0
          const filters = Object.keys(filteringObject)
          filters.forEach((key) => {
            const splitKey = key.split('.')
            let fabricValue = fabricOption
            for (let x = 0; x < splitKey.length; x++) {
              fabricValue = fabricValue[splitKey[x]]
              if (!fabricValue) {
                break
              }
            }
            if (fabricValue) {
              if (typeof fabricValue == 'object') {
                // This will handle the array and object ones
                if (fabricValue.length) {
                  // This is for the array
                  for (let x = 0; x < fabricValue.length; x++) {
                    if (filteringObject[key].includes(fabricValue[x])) {
                      matches ++
                      break
                    }
                  }
                  
                }
                // TODO objects
              } else {
                // String
                if (filteringObject[key].includes(fabricValue)) {
                  matches ++ 
                }
              }
            }
          })
          if (matches === filters.length) {
            return true
          }
          return false 
          
        })
      }
      return fabricOptionsCopy;
    },
    activeOption() {
      return this.$store.getters[this.activeOptionFunction];
    },
    defaultValue() {
      return this.$store.getters[this.defaultValueFunction];
    },
    emptyOption() {
      return this.$store.getters[this.emptyOptionFunction];
    },
    chooseNowOption() {
      return this.$store.getters[this.chooseNowOptionFunction];
    },
    decideLaterOption() {
      return this.$store.getters[this.decideLaterOptionFunction];
    },
    chooseText() {
      return this.$store.getters[this.chooseTextFunction];
    },
    decideLaterText() {
      return this.$store.getters[this.decideLaterTextFunction];
    },
    ...mapGetters({
      productTitle: "products/getProductTitle",
      activeImage: "images/getActiveImage",
      activeProduct: "products/getActiveProduct",
      fabricFilters: "fabrics/getFilters",
      colorConfig: "fabrics/getColorConfig",
      activeFilters: "fabrics/getActiveFilters"
    }),
    activeImageUrl() {
      return  window.location ? 
        this.activeImage && !this.activeImage.includes(window.location.origin) ?
          `${window.location.origin}/cdn/shop/${this.activeImage}` :
          this.activeImage
        : this.activeImage
    },
    isInverted() {
      if (this.activeProduct.orientation && this.activeProduct.orientation.match(/right/i)?.length) {
        return true
      }
      return false
    }
  },
  mounted() {
    if (this.activeOption != this.decideLaterOption) {
      this.displayedOption = this.activeOption;
    } else {
      this.displayedOption = this.options[0];
    }
    if (this.modalOpen) {
      document.querySelector('body').classList.remove('mr--modal-open')
      document.querySelector('html').classList.remove('mr--modal-open')
    }
    setTimeout(() => {
      // TODO maybe surpress initial lazyload?
      if (this.displayedOption != this.decideLaterOption) {
        this.maybeSetRenderingImage()
      }
    }, 100)
    
  },
  methods: {
    onModalOpen() {
      if (this.isOpen) {
        if (this.observer) {
          this.observer.unobserve(this.$refs.modalActions)
          if (this.$el.classList.contains(this.STICKY_CLASS)) {
            this.$el.classList.remove(this.STICKY_CLASS);
          }
        }
        this.setupStickyATC()
        // this.maybeSetRenderingImage()
      }
    },
    handleDecideLater() {
      this.$store.dispatch(this.setFunction, this.decideLaterOption);
      this.$store.dispatch(this.setStateFunction, true);
      this.displayedOption = this.options[0];
      this.$emit("option-changed");
      // this.$emit("close-dropdown");
    },
    handleFabricSelect() {  
      this.$store.dispatch(this.setFunction, this.displayedOption);
      this.$store.dispatch(this.setStateFunction, false);
      this.$emit("option-changed");
      this.maybeSetRenderingImage()
      this.handleModalOpen();
      this.$emit("close-dropdown");
    },
    handleDropDownClick() {
      if (this.isOpen) {
        this.$emit("close-dropdown");
        // this.handleModalOpen(true);
      } else {
        this.$emit("open-dropdown");
        if (this.activeOption !== this.decideLaterOption) {
          this.handleModalOpen(true);
        }
      }
    },
    checkClick(e) {
      if (e.target.classList.contains("modal_overlay")) {
        this.handleModalOpen();
        this.filtersOpen = false
      }
    },
    checkKeyDown(e) {
      if (e.keyCode == 27) {
        this.handleModalOpen();
      }
    },
    handleModalOpen(openModal = false) {
      this.modalOpen = openModal;
    },
    handleYAMLClick(yamlOption) {
      const yamlSKU = yamlOption.sku_code;
      const newOption = this.options.find(
        (option) => option.sku_code === yamlSKU
      );
      if (newOption) {
        this.displayedOption = newOption;
        this.$store.dispatch(this.setFunction, this.displayedOption);
        this.$store.dispatch(this.setStateFunction, false);
        this.maybeSetRenderingImage()
        this.$emit("option-changed");
      }
    },
    handleOptionClick(option) {
      this.displayedOption = option;
      this.$store.dispatch(this.setFunction, this.displayedOption);
      this.$store.dispatch(this.setStateFunction, false);
      this.maybeSetRenderingImage()
      this.$emit("option-changed");
    },
    handleDFLOption() {
      this.handleDecideLater();
      this.$emit("close-dropdown");
    },
    setupStickyATC() {
      if (this.$refs.modalActions) {
        const handler = (entries) => {
          if (!entries[0].isIntersecting) {
            if (!this.$el.classList.contains(this.STICKY_CLASS)) {
              this.$el.classList.add(this.STICKY_CLASS);
            }
            
          } else {
            if (this.$el.classList.contains(this.STICKY_CLASS)) {
              this.$el.classList.remove(this.STICKY_CLASS);
            }
          }
        };

        const options = {};
        this.observer = new window.IntersectionObserver(handler, options);
        this.observer.observe(this.$refs.modalActions);
      }
    },
    maybeSetRenderingImage() {
      let workingTitle = this.displayedOption.title || ''
      workingTitle = workingTitle.toLowerCase().split(" ").map((part) => {
        return (part.split('').map((elm, index) => index === 0 ? elm.toUpperCase() : elm)).join('')
      }).join("_")

      let workingProduct = this.productTitle.replaceAll(" ",'_').replaceAll("'",'_').toUpperCase()
      
      let workingUrl = `${window.location.origin}${this.IMAGE_URL_TEMPLATE}`.replace('{productTitle}', workingProduct).replace('{fabricName}',workingTitle)
      axios.get(workingUrl).then(() => {
        this.$store.dispatch("images/activateImage", workingUrl);
        document.dispatchEvent(new CustomEvent('update-rendering', {
          detail: {
            url: workingUrl
          }
        }))
      }).catch(() => {
        // Fail Request try with uppercase
        workingUrl = `${window.location.origin}${this.IMAGE_URL_TEMPLATE}`.replace('{productTitle}', workingProduct.toUpperCase()).replace('{fabricName}',workingTitle.toUpperCase())
        axios.get(workingUrl).then(() => {
          this.$store.dispatch("images/activateImage", workingUrl);
          document.dispatchEvent(new CustomEvent('update-rendering', {
            detail: {
              url: workingUrl
            }
          }))
        }).catch(()=> {
          // Fail Request, don't update
        })
      })
    },
    handleFilterClick(filterIndex) {
      // It'll either be null or a single
      let currentFilter = this.$refs.filter
      let currentContent = this.$refs.content
      if (this.$refs.filter && this.$refs.filter.length) {
        // THIS IS AN ARRAY, handle it accordingly
        currentFilter = this.$refs.filter[filterIndex]
        currentContent = this.$refs.content[filterIndex]
      }
      if (currentFilter) {
        if (currentFilter.classList.contains('active')) {
          currentFilter.classList.remove('active')
          currentContent.style.maxHeight = null;
        } else {
          currentFilter.classList.add('active')
          currentContent.style.maxHeight = currentContent.scrollHeight + 'px';
        }
      }
    },
    handleFilterSelected(filter,value) {
      this.$store.dispatch("fabrics/activateFabricFilter", {filterToActivate:filter, filterValue:value, joinActiveFilters: true});
    }
  },
};
</script>
<style scoped>
.dropdown__container {
  /* padding: 10px 10px 5px; */
  border: var(--border-thickness) solid;
  cursor: pointer;
}
.selected_wrapper {
  display: flex;
  align-items: center;
}
.dropdown_label {
  padding: 10px 10px;
}
.dropdown_label img {
  margin-left: 10px;
}
.dropdown_label span {
  margin-left: 15px;
}
.selected_wrapper.open .dropdown_label {
  background-color: var(--active-option-background);
  color: var(--active-option-foreground);
}
.chooseNowOption {
  transition: 0.2s ease-out;
}
.chooseNowOption:hover {
  background-color: var(--active-option-background);
  color: var(--active-option-foreground);
}
.chevron {
  height: 1rem;
  transition: 0.2s ease-in;
  margin: 10px;
}
.chevron.active {
  transform: rotate(180deg);
}
.dropdown_label {
  flex-grow: 1;
  text-align: center;
  user-select: none;
  position: relative;
}
.option_container {
  overflow: hidden;
  overflow-y: scroll;
  text-align: center;
  padding: 10px 10px 5px;
}
.image_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.details_wrapper {
  max-width: 350px;
  margin: 0 auto;
  margin-bottom: 10px;
  padding: 10px 20px 15px;
  box-sizing: border-box;
  font-size: 14px;
  background-color: var(--option-details-background);
  color: var(--option-details-foreground);
  user-select: none;
  line-height: 1.2;
}

.description {
  letter-spacing: -0.25px;
  font-size: 13px;
}

.details_wrapper >>> a {
  color: var(--option-details-foreground);
  padding: 5px;
  text-decoration: none;
  border: 1px solid;
  display: flex;
  width: fit-content;
  margin: 15px auto 0;
  letter-spacing: unset;
  font-size: 14px;
  transition: 0.3s ease-in-out;
}

.details_wrapper >>> a:visited {
  color: var(--option-details-foreground);
}
.details_wrapper >>> a:hover {
  color: var(--option-details-background);
  background-color: var(--option-details-foreground);
  border-color: var(--option-details-foreground);
}
.option {
  padding-bottom: 10px;
  user-select: none;
  line-height: 1.2;
  font-size: 14px; 
}
.option:not(.details_wrapper .option) {
  padding: 5px;
  margin: 10px 0;
}
img.thumbnail {
  min-height: 80px;
}
img:not(.thumbnail) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.dropdown_label img {
  height: 25px;
  width: 25px;
  min-height: unset;
  position: absolute;
  left: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.modal_wrapper {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1043;
  position: fixed;
  outline: 0 !important;
  -webkit-backface-visibility: hidden;
}
.modal_overlay {
  /* background: var(--modal-overlay-color); */
  opacity: var(--modal-overlay-opacity);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}
.modal_container {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.modal_content {
  /* border: 2px solid; */
  border-color: var(--modal-border-color);
  background: var(--modal-content-background);
  color: var(--modal-content-foreground);
  padding: 20px 10px 0;
  position: relative;
  width: 100%;
  max-width: 500px;
  box-shadow: 0px 0px 10px 2px #000;
  /* margin: 50px 20px; */
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
h3 {
  margin: 0;
  font-size: 22px;
}
.modal_heading {
  margin-bottom: 10px;
  text-align: center;
  width: 100%;
}
.action_button {
  border: 2px solid var(--button-background);
  background: var(--button-background);
  color: var(--button-foreground);
  cursor: pointer;
  transition: 0.2s ease;
  padding: 8px 10px;
  text-align: center;
  user-select: none;
  font-size: 12px;
  flex-grow: 1;
  /* width: 100%; */
}
.button_container {
  display: grid;
  row-gap: 5px;
  align-items: center;
}
.action_button:not(.disabled):hover {
  opacity: var(--hover-opacity);
}
.action_button.inverse {
  border: 2px solid var(--button-background);
  color: var(--button-background);
  background: transparent;
}
.action_button.inverse:not(.disabled):hover {
  color: var(--button-foreground);
  background: var(--button-background);
}
.mobile--second {
  grid-row-start: 2;
}
.scroll_container {
  overflow: scroll;
  max-height: calc(100% - 30px);
  transition: 0.4s ease-in-out;
  width: 100%;
  position: relative;
}

.modal_options {
  margin: 20px 0;
  /* max-height: 250px; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 10px;
  column-gap: 10px;
  /* overflow: scroll; */
}
.modal_option {
  height: 120px;
}
.modal_option,
.modal_yaml_one,
.modal_yaml_two {
  transition: 0.2s ease-in;
}
.modal_option:not(.is_active),
.modal_yaml_one,
.modal_yaml_two {
  cursor: pointer;
}
.modal_option:not(.is_active):hover,
.modal_yaml_one:hover,
.modal_yaml_two:hover {
  opacity: var(--hover-opacity);
}
.modal_active_container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 120px);
  overflow: scroll;
  width: 100%;
}
.modal_option,
.modal_active_option,
.modal_yaml_one,
.modal_yaml_two {
  position: relative;
  border: 1px solid;
  border-color: var(--modal-border-color);
}
.modal_active_option {
  grid-column-start: 1;
  grid-column-end: 3;
}
.modal_yaml_one,
.modal_yaml_two {
  overflow: hidden;
  display: none;
}
.modal_yaml_two {
  grid-row-start: 2;
}
.modal_text {
  position: absolute;
  top: 15px;
  left: 15px;
  line-height: 1;
  padding: 5px;
  z-index: 1;
  color: var(--modal-option-text);
}
.yaml_heading {
  font-size: 12px;
  margin-bottom: 10px;
}
.option_title {
  margin-bottom: 5px;
  margin-right: 5px;
}
.option_collection {
  font-size: 12px;
  font-style: italic;
}
.active_ring {
  border: 12px solid;
  border-color: var(--border-color);
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 1;
}
.modal_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
  background: var(--modal-image-background-color);
}
.modal_option .modal_image {
  position: absolute;
  top: 0;
  left: 0;
}
.closer {
  /* position: absolute; */
  right: 0;
  font-size: 2.5em;
  overflow: visible;
  cursor: pointer;
  background: 0 0;
  border: 0;
  outline: 0;
  z-index: 1046;
  padding-right: 5px;
  top: 5px;
  line-height: 0.5;
  color: #000!important;
  padding: 0;
  width: 25px;
  height: 25px;
}
/* .closer {
  position: absolute;
} */
.sticky-fabrics {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: white;
  transition: 0.4s ease-in-out;
  transform: translateY(100%);
}
.sticky-stuck .sticky-fabrics {
  transform: translateY(-10px);
}
.sticky-stuck .scroll_container {
  max-height: calc(100% - 130px);
}
.sticky-fabric-wrapper {
  padding: 10px;
  border-top: 4px solid;
}

.sticky-fabric-details {
  display: flex;
  gap: 10px;
  margin-bottom: 5px;
}
.sticky-image {
  width: 40px;
  height: 40px;
  overflow: hidden;
  box-sizing: border-boxox;
}
.lightBG {
  border: 2px solid var(--modal-border-color);
}
.sticky-fabric__filter-open {
  width: 45px;
  height: 45px;
  padding: 5px;
  box-sizing: border-box;
  border: 2px solid;
  cursor: pointer;
}
.sticky-fabric-details--content {
  line-height: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  
}
.sticky-collection {
  font-size: 12px;
  font-style: italic;
}
.detail_background {
  background: var(--detail-background-color);
}
.flex-wrapper {
  display: flex;
  gap: 5px;
}
.sticky-fabric-details .action_button {
  display: none;
}
.active-image_wrapper {
  position: sticky;
  top: 0;
  z-index: 10;
  padding-bottom: 10px;
  background: white;
}
.active-image_wrapper .image_container {
  border: 2px solid;
  box-sizing: border-box;
  height: 175px;
}
.active-image_wrapper img {
  object-position: 0% 75%;
  transition: 0.2s ease;
}
.active-image_wrapper.product__images--invert img {
  transform: scale(-1,1);
}
.filters_container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.filters_overlay {
  background: #000;
  opacity: 0.3;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
}
.filters_wrapper {
  height: 50%;
  background: white;
  position: absolute;
  bottom: 0;
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  padding: 20px 10px 0;
  box-shadow: 0px 0px 10px 2px #000;
  border-top: 2px solid;
}
.filters_wrapper .closer {
  align-self: flex-end;
}
.filters_container h3 {
  text-transform: uppercase;
  text-align: center;
  font-size: 22px;
}

.fade-enter-active .filters_wrapper,
.fade-leave-active .filters_wrapper {
  transition: transform 0.5s;
}
.fade-enter .filters_wrapper,
.fade-leave-to .filters_wrapper {
  transform: translateY(100%);
}
.filter_toggle {
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
  cursor: pointer;
  align-items: center;
}
.filter_indicator {
  position: relative;
  width: 20px;
  display: flex;
}
.td--vertical-part {
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(90deg);
  transition: 0.5s ease-in-out;
}
.td--horizontal-part {
  width: 100%;
}
.active .td--vertical-part {
  transform: rotate(180deg);
}
.filter_values {
  max-height: 0;
  overflow: hidden;
  transition: 0.5s ease;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.filter {
  padding: 10px 0;
  border-bottom: 1px solid;
}
.filters {
  padding-bottom: 20px;
  overflow: hidden;
  overflow-y: scroll;
}
.filter-option {
  padding: 10px 15px;
  display: flex;
  justify-content: center;
  /* align-items: center; */
  gap: 5px;
  border: 1px solid;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 1;
}
.colour-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background: var(--filter-colour, #000);
  display: flex;
  margin-top: 1px;
}
/* .filter-option:hover {
  
} */
.filter-option.active {
  background: var(--modal-content-foreground);
  color: var(--modal-content-background);
}
@media screen and (min-width: 768px) {
  .mobile--second {
    grid-row-start: unset;
  }
  .closer {
    right: 5px;
  }
  h3 {
    font-size: 26px;
  }
 
  .action_button {
    /* width: 100%;
    max-width: 190px; */
  }
  /* .modal_active_container {
    grid-template-rows: repeat(2, 120px);
  } */
  
  .modal_content,
  .filters_wrapper {
    padding: 30px 20px 0;
  }
  .filters_wrapper {
    width: calc(100% - 40px);
  }
}
@media screen and (min-width: 1024px) {
  .modal_options {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (min-width: 1280px) {
  .details_wrapper {
    padding: 10px 45px 15px;
  }
  .modal_yaml_one,
  .modal_yaml_two {
    display: block;
  }
  .modal_active_container {
    grid-template-rows: repeat(2, 120px);
  }
  .active-image_wrapper {
    display: none;
  }
  .modal_heading {
    margin-bottom: 20px;
  }
}
@media screen and (min-width: 768px) {
  .description {
    font-size: 15px;
    letter-spacing: 0px;
  }
  .chooseNowOption,
  .option {
    font-size: 16px;
  }
  .sticky-fabric-wrapper > .action_button {
    display: none;
  }
  .sticky-fabric-wrapper {
    padding: 10px 20px 5px;
  }
  .sticky-image {
    width: 45px;
    height: 45px;
  }
  .sticky-fabric-details .action_button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sticky-stuck .scroll_container {
    max-height: calc(100% - 110px);
  }
}
</style>
